import { authenticatedApi } from './api';
const getWorklogsFromToDate = async (fromDate: string, toDate: string) => {
  return authenticatedApi.post('tempo/worklogs', { fromDate, toDate });
};
const tempoApi = { getWorklogsFromToDate };

export default tempoApi;
